export default __webpack_public_path__ + "static/media/fld_bi_white.f389f9d4.svg";